import React from 'react'

export const ScreenReaderHint: React.FC<{ hint: string }> = ({ hint }) => (
  <span className="sr-only">{hint}</span>
)
